// @flow
import * as React from 'react';

import { useRouter } from 'next/router';
import { Link } from '@i18n';

import { StyledLinkNavigation } from './styles';

const NavigationLink = ({
  label, route, heroSection
}: {
  label: string, route: string, heroSection?: boolean
}): React.Node => {
  const {
    query: { nextRoute: currentRoute }
  }: { query: { nextRoute: string } } = useRouter();
  return (
    <Link href={route} passHref>
      <StyledLinkNavigation active={currentRoute === route} heroSection={heroSection}>
        {label}
      </StyledLinkNavigation>
    </Link>
  );
};

export default NavigationLink;
